export const NFT_SCHEMA_VERSION = '0.4.0';
